
<template>
  <div class="concurrentEvents" :concurrentEvents="concurrentEvents">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" v-for="(item,index) in concurrentEvents.slice(0,2)" :key="index">
        <div class="concurrentEventsBox">
          <div class="concurrentEventsBoxImage">
            <img :src="item.liveImgUrl" />
          </div>
          <p class="concurrentLivename">{{item.liveName}}</p>
          <div class="concurrentDivider"></div>
          <div class="concurrentEventsBoxHeaderImage">
            <img :src="item.anchorImgUrl"  @error="defImg()"/>
          </div>
          <div class="concurrentEventsBoxName ellipsis">{{item.anchorName}}</div>
          <div class="concurrentEventsMask">
              <div class="enter" @click="Enter(item)">
                  {{$t('homes.bookingNow')}}
              </div>
          </div>
        </div>
        
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { eventMixin } from '@/mixins/event.js'
export default {
  props: {
    concurrentEvents: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  mixins: [eventMixin],
  data() {
    return {
      lableList:[]
    }
  },
  computed: {},
  mounted() {

  },
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defImage('head');
      img.onerror = null; //防止闪图
    },
    Enter(item){
      console.log(item)
        this.liveEvent(item.id)
    }
  },
  created() {}
}
</script>
<style lang="stylus" scoped>
</style>
